import styles from "./FaturasAdmin.module.css";
import { useEffect, useState } from "react";
import load from "../../../../Images/loading.gif";

function FaturasAdmin() {
    const [faturas, setFaturas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        const fetchFaturas = async () => {
            try {
                const response = await fetch(`https://eclipsebots.com/api/faturas/get`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch invoices");
                }

                const data = await response.json();
                setFaturas(data.results);
            } catch (error) {
                console.error("Erro ao buscar faturas:", error);
                setFaturas([]);
            } finally {
                setLoading(false);
            }
        };

        fetchFaturas();
    }, []);


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    const filteredInvoices = faturas.filter(fatura =>
        fatura.userId.includes(search.toLowerCase()) ||
        String(fatura.invoiceId).includes(search)
    );

    return (
        <div className={styles.faturas}>
            <div className={styles.title}>Faturas</div>
            {faturas.length === 0 ? (
                <div className={styles.noData}>
                    Não existe nenhuma fatura de momento.
                </div>
            ) : (
                <div className={styles.fat}>
                    <input
                        type="text"
                        placeholder="Procurar uma fatura..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className={styles.searchInput}
                    />
                    <div className={styles.overflow}>
                        {filteredInvoices.map((fatura, index) => {
                            const isFirst = index === 0;
                            const isLast = index === faturas.length - 1;

                            return (
                                <div key={fatura.invoiceId} className={`${styles.fatura} ${isFirst ? styles.first : ""} ${isLast ? styles.last : ""}`}>
                                    <div className={styles.image}>
                                        <img src={fatura.serviceImage} alt="Imagem de Perfil" />
                                    </div>
                                    <div className={`${styles.emoji} ${styles.imagem}`}>
                                        {getEmoji(fatura.status)}
                                    </div>
                                    <div className={`${styles.name} ${styles.imagem}`}>
                                        Fatura <strong>#{fatura.invoiceId}</strong> {fatura.status === "paid" ? (
                                            <span>Paga a {new Date(fatura.paidAt).toLocaleString()}</span>
                                        ) : `${fatura.status === "pending" ? "por pagar" : "com o pagamento cancelado"}. (Gerada a ${new Date(fatura.issuedAt).toLocaleString()})`}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

const getEmoji = (type) => {
    switch (type) {
        case "pending": return "🕒";
        case "cancelled": return "🔴";
        case "failed": return "🔴";
        case "paid": return "🟢";
        default: return "🔔";
    }
};

export default FaturasAdmin;